import React, { PureComponent, useContext } from 'react';
import PropTypes from 'prop-types';

import ShowChartOutlinedIcon from '@material-ui/icons/ShowChartOutlined';
import DataUsageOutlinedIcon from '@material-ui/icons/DataUsageOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import LoyaltyOutlinedIcon from '@material-ui/icons/LoyaltyOutlined';
import SettingsApplicationsOutlinedIcon from '@material-ui/icons/SettingsApplicationsOutlined';
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import WidgetsOutlinedIcon from '@material-ui/icons/WidgetsOutlined';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';

import FiranoIcon from 'cityads-v3/components/Icons/FiranoIcon';

import Carousel, { SlideCardContext } from './Carousel';
import { ClickableCardWithPopup } from '../CardWithPopup';
import Typography from '@material-ui/core/Typography'

import classes from './ToolsCarousel.scss'

export const ALLOWED_PATHS = [
  'statistics',
  'big_data',
  'agent_cabinet',
  'firano',
  'product_feed',
  'coupon_feed',
  'getlink',
  'api',
  'conversion_postback',
  'widgets',
  'lost_orders',
];

const ICONS = {
  show_chart: <ShowChartOutlinedIcon />,
  data_usage: <DataUsageOutlinedIcon />,
  exit_to_app: <ExitToAppOutlinedIcon />,
  attach_money: <FiranoIcon />,
  shopping_cart: <ShoppingCartOutlinedIcon />,
  loyalty: <LoyaltyOutlinedIcon />,
  settings_applications: <SettingsApplicationsOutlinedIcon />,
  refresh: <RefreshOutlinedIcon />,
  widgets: <WidgetsOutlinedIcon />,
  find_in_page: <FindInPageOutlinedIcon />,
}

export default class ToolsCarousel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    limits   : PropTypes.object,
    items    : PropTypes.arrayOf(PropTypes.object).isRequired,
    moreRoot : PropTypes.string,
    lessLink : PropTypes.string,
  }

  render() {
    const { items, moreRoot, lessLink, ...rest } = this.props;

    return (
      <Carousel
        {...rest}
      >
        {items.map((item, index) => (
          <CarouselCardWrapper key={index} {...item} moreRoot={moreRoot} lessLink={lessLink} />
        ))}
      </Carousel>
    );
  }
}

function CarouselCardWrapper({ icon, title, subtitle, moreRoot, moreLink, lessLink, flag, children, ...rest }) {
  const getHidePopup = useContext(SlideCardContext);

  return (
    <ClickableCardWithPopup
      {...rest}
      icon      = {ICONS[icon]}
      title={<Typography component="h3" color="textPrimary">{title}</Typography>}
      subtitle  = {<div className={classes.cardSubtitle}>{subtitle}</div>}
      isMini    = {true}
      moreLink  = {moreLink ? (moreRoot + '/' + moreLink) : null}
      lessLink  = {lessLink}
      hidePopup = {getHidePopup}
      classes   = {{ root: classes.cardRoot }}
      cardHeaderClasses  = {{ root: classes.cardHeader, title: classes.cardHeaderTitle, subheader: classes.cardHeaderSub }}
      cardContentClasses = {{ root: classes.cardContent }}
    >
      <div className={classes.cardContainerStyle}>
        {flag ?
          (
            <span className={classes.cardFlag}>{flag}</span>
          ) :
          null
        }
        {children}
      </div>
    </ClickableCardWithPopup>
  );
}
